import React from 'react'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '../ui/sheet'
import { Download, Loader2, Paperclip } from 'lucide-react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { useMutation } from 'react-query'
import axios from 'src/axios/axios'
import { downloadFile } from 'src/functions/actions/documents'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'

type Props = {
    attachments?: Attachment[]
    token?: string
}

const Attachments = ({attachments, token}:Props) => {
    const { t, i18n } = useTranslation()

    const { mutate:downloadDocument, isLoading } = useMutation({
        mutationFn: async (id:number) => {
            try {
                toast.loading(`${t('Bijlage downloaden')}...`, {id:'downloadDocument', position:'top-center'})
                const { data } = await axios.get(`/attachments?attachmentid=${id}`)
                if(data.errorcode!==0){ throw new Error(data.message) }
                downloadFile(data.object.file, data.object.filename)
                toast.success(`${t('Bijlage gedownload')}!`, {id:'downloadDocument', position:'top-center'})
            } catch (error) {
                console.log(error);
                toast.error(`${t('Bijlage downloaden mislukt')}`, {id:'downloadDocument', position:'top-center'})
            }
        }
    })

  return (
    <Sheet>
        <SheetTrigger asChild><button className='flex items-center justify-center w-10 h-10 bg-white rounded-full hover:bg-slate-200'><Paperclip className='w-5 text-slate-500'/></button></SheetTrigger>
        <SheetContent className='md:max-w-[600px] md:w-full'>
            <SheetTitle>{t('Bijlages')}</SheetTitle>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead className='w-16'></TableHead>
                        <TableHead>{t('Datum')}</TableHead>
                        <TableHead>{t('Bestandsnaam')}</TableHead>
                        <TableHead>{t('Opmerking')}</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {Array.isArray(attachments) && attachments.map((attachment,i)=>(
                        <TableRow key={i}>
                            <TableCell>
                                <button disabled={isLoading} onClick={()=>{downloadDocument(attachment.documentsattachmentsid)}} className='flex items-center justify-center w-8 h-8 rounded-full bg-slate-50 text-slate-600'>
                                    {isLoading ? <Loader2 className='w-4 h-4 animate-spin'/> : <Download className='w-4 h-4'/>}
                                </button>
                            </TableCell>
                            <TableCell>{attachment?.datecreated}</TableCell>
                            <TableCell>{attachment?.filename}</TableCell>
                            <TableCell>{attachment?.remark}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </SheetContent>
    </Sheet>
  )
}

export default Attachments